import { useEffect, useRef } from 'react';
import SubscriptionPage from '../pages/SubscriptionPage';
import './SubscribeModal.css';

export default function SubscribeModal({ onClose }) {
  const panelRef = useRef(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    panelRef.current?.focus();

    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="sub-modal" role="dialog" aria-modal="true" aria-labelledby="sub-modal-title">
      <button type="button" className="sub-modal__backdrop" aria-label="Close" onClick={onClose} />
      <div className="sub-modal__panel" ref={panelRef} tabIndex={-1}>
        <SubscriptionPage embedded onClose={onClose} />
      </div>
    </div>
  );
}
